var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-menu",
    transform: "translate(-331 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148645",
    "data-name": "Rectangle 148645",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(331 20)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148646",
    "data-name": "Rectangle 148646",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(331 28)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148647",
    "data-name": "Rectangle 148647",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(331 36)",
    fill: "#0c0c0b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.6a6cbdba.svg";
export { ForwardRef as ReactComponent };